export default __webpack_public_path__ + "static/media/logo.46626f7c.png";